import React from 'react';
import { useAppSelector } from '../../../core/rootHooks';
import { formatDateAsString } from '../../../utils/helpers';
import { selectSignedInUserPublishedScenarioName } from '../../../user-management/appSelectors';


const InfoNote: React.FC = () => {
    const scenarioName: string = useAppSelector(selectSignedInUserPublishedScenarioName);
    const relatedDate = new Date().toString();
    const formattedDate = formatDateAsString(relatedDate, { year: 'numeric', month: 'long' });

    return (
        <div>
            <div className='flex flex-row gap-8'>
                <div className="text-msi-darkgrey-color text-sm font-semibold">
                    as of {formattedDate} (MSI Scenario {scenarioName})
                </div>
            </div>
        </div>
    );
};

export default InfoNote;